import {createAction, props} from '@ngrx/store';
import {ReuseBelegData} from '../../interfaces/reuse-beleg-data.interface';

export class BelegStipulatedDialogActions {
  public static open = createAction(
    '[Overview- & Edit-Page] Open beleg-stipulated-dialog.',
    props<{
      data: ReuseBelegData;
    }>(),
  );

  public static close = createAction('[Beleg-Stipulated-Dialog] Close beleg-stipulated-dialog.');
}
